module.exports = __webpack_public_path__ + "img/SIKH TURBAN BW.685f3dc.svg";